import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import CustomerService from '../assets/icons/BPS Icon - Customer Service.png';
import CustomIconRed from '../assets/icons/BPS Icon - Custom-Red.png';
import MonitorPhone from '../assets/icons/BPS Icon - Monitor + Phone.png';
import Security from '../assets/icons/BPS Icon - Security-Green.png';
import Rocket from '../assets/icons/BPS Icon - Rocket.png';

import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';
import { BPSPrimaryButton } from '../components/styled/Buttons';



const CustomIncentivePrograms = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Custom Incentive Programs</title>
                <link rel="canonical" href="https://bestpayment.solutions/custom-incentive-programs" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 circle-bg-2-fixed'>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col lg={10}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Custom Incentive Programs</h2>
                            <h1 className='fs-48'>
                                Looking for something unique?
                                <br />
                                Let’s create the perfect program together!
                            </h1>
                        </FadeLoad>
                    </Col>
                    <Col lg={8} className='py-4'>
                        <FadeLoad>
                            <p className='py-4'>
                                Very few things in life are “one size fits all”, and incentive programs are no different. If you can not find what you’re looking for among our listed offerings, we can work with you to create a program that will fit your specific needs and goals. Reach out to our team and let us find out what we can build together.
                            </p>
                            <BPSPrimaryButton href='/schedule-demo'>Contact our team</BPSPrimaryButton>
                        </FadeLoad>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='text-center py-5 bg-cream'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col lg={6}>
                            <h3 className='fs-48'>Essential features included with every program</h3>
                            <p>
                                Whether it’s a pre-designed program or a custom-build, you can expect these core features to ensure your success and user satisfaction. We are committed to delivering excellence in every detail.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly">
                    <Col xxl={3} sm={5} className='py-3'>
                        <img src={Rocket} width={60} />
                        <h4 className='fs-20 pt-4'>Fast-track setup</h4>
                        <p>
                            Time is our most valuable resource. We understand the importance of a quick program launch. Most programs (even custom ones!) can go live within 60-90 days.
                        </p>
                    </Col>
                    <Col xxl={3} sm={5} className='py-3'>
                        <img src={CustomIconRed} width={60} />
                        <h4 className='fs-20 pt-4'>Simple & seamless</h4>
                        <p>
                            We build platforms that are easy for your team and participants to use. Plus, we can create programs that blend with your style for a seamless brand experience.
                        </p>
                    </Col>
                    <Col xxl={3} sm={5} className='py-3'>
                        <img src={MonitorPhone} width={60} />
                        <h4 className='fs-20 pt-4'>Accessible from anywhere</h4>
                        <p>
                            Our incentive programs are designed for the digital world. We prioritize accessibility and device compatibility. This ensures your users always have easy access to your program.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly">
                    <Col xxl={3} sm={5} className='py-3'>
                        <img src={Security} width={60} />
                        <h4 className='fs-20 pt-4'>Top-notch security</h4>
                        <p>
                            We always protect participant data. Our state-of-the-art security includes safe account features including two-factor authentication.
                        </p>
                    </Col>
                    <Col xxl={3} sm={5} className='py-3'>
                        <img src={CustomerService} width={60} />
                        <h4 className='fs-20 pt-4'>Customer service support</h4>
                        <p>
                            All of our programs are backed by our team of customer service representatives. They know your program top to bottom so they can answer any questions from your participants.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default CustomIncentivePrograms;